import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "iodine-references-header" }
const _hoisted_2 = { class: "references-option" }
const _hoisted_3 = { class: "references-search-bar" }

import { onMounted, ref } from 'vue';
import { TitledObject } from 'src/services/TrucodeReferencesService';
import { useTrucodeReferenceStore } from 'stores/references-store';
import DropDown from 'components/global-common/DropDown.vue';
import SearchBar, { GenericSearchOption } from 'components/global-common/SearchBar.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesHeader',
  emits: ["referencesOptionChanged"],
  setup(__props, { emit: __emit }) {

const referencesOption = ref('search');

const searchOption = ref<string>('');
const browseOption = ref<string>('');
const bookReferences = ref<TitledObject[]>([]);
const searchBarRef = ref<InstanceType<typeof SearchBar> | null>(null);

const emit = __emit

const referencesStore = useTrucodeReferenceStore();

onMounted(async () => {
  const result = await referencesStore.getSearchBookReference();
  bookReferences.value = result || [];
});

function bookChanged(referencesBook: TitledObject) {
  referencesStore.setCurrentBook(referencesBook);
  searchBarRef.value?.search();
}

async function referencesOptionChanged(value: string) {

  if (value == 'search') {
    bookReferences.value = await referencesStore.getSearchBookReference() || [];
  } else {
    bookReferences.value = await referencesStore.getBrowseBookReference() || [];
  }

  emit('referencesOptionChanged', value)
}

function searchChanged(text: string): Promise<GenericSearchOption[]> {

    return referencesStore.getReferenceBookTermSearch('' + text);
}


return (_ctx: any,_cache: any) => {
  const _component_q_radio = _resolveComponent("q-radio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_radio, {
        modelValue: referencesOption.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((referencesOption).value = $event)),
          referencesOptionChanged
        ],
        val: "search",
        label: "Search"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_radio, {
        modelValue: referencesOption.value,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => ((referencesOption).value = $event)),
          referencesOptionChanged
        ],
        val: "browse",
        label: "Browse"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createVNode(DropDown, {
        modelValue: searchOption.value,
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => ((searchOption).value = $event)),
          bookChanged
        ],
        options: bookReferences.value,
        "option-label": "title",
        "option-value": "id",
        label: "Book",
        "iodine-class-name": "references-book"
      }, null, 8, ["modelValue", "options"]), [
        [_vShow, referencesOption.value === 'search']
      ]),
      _withDirectives(_createVNode(DropDown, {
        modelValue: browseOption.value,
        "onUpdate:modelValue": [
          _cache[3] || (_cache[3] = ($event: any) => ((browseOption).value = $event)),
          bookChanged
        ],
        options: bookReferences.value,
        "option-label": "title",
        "option-value": "id",
        label: "Book",
        "iodine-class-name": "references-book"
      }, null, 8, ["modelValue", "options"]), [
        [_vShow, referencesOption.value === 'browse']
      ]),
      _createVNode(SearchBar, {
        search: searchChanged,
        "class-name": "references",
        ref_key: "searchBarRef",
        ref: searchBarRef,
        "show-results-menu": false,
        disable: referencesOption.value !== 'search' || !searchOption.value
      }, null, 8, ["disable"])
    ])
  ]))
}
}

})